import styled from 'styled-components';
import I18n from 'I18n';
import { jsx as _jsx } from "react/jsx-runtime";
const DisclaimerText = styled.div.withConfig({
  displayName: "SpotlightAIDisclaimer__DisclaimerText"
})(["font-size:", ";text-align:center;padding:0 ", " ", ";color:", ";"], ({
  theme
}) => theme.spotlight.typography.fontSize.sm, ({
  theme
}) => theme.spotlight.spacing.lg, ({
  theme
}) => theme.spotlight.spacing.md, ({
  theme
}) => theme.spotlight.color.muted);
export default function SpotlightAIDisclaimer({
  disclaimerText
}) {
  const text = disclaimerText !== null && disclaimerText !== void 0 ? disclaimerText : I18n.text('conversations-visitor-experience-components.aiDisclaimer');
  return /*#__PURE__*/_jsx(DisclaimerText, {
    "data-test-id": "spotlight-ai-disclaimer",
    "aria-label": text,
    children: text
  });
}
SpotlightAIDisclaimer.displayName = 'SpotlightAIDisclaimer';